import { useQuery } from '@tanstack/react-query';
import defaultFetch from 'react/api/sagas/fetch/defaultFetch';
import { getStopStatus } from 'react/utils/stopUtils';

const mapStopStatus = (stopView) => {
  const { stop } = stopView;
  const stopStatus = getStopStatus(stop);

  stop.deliveryStatus = stopStatus;

  return stopView;
};

async function getStopList(routeId) {
  const criteriaParams = {
    filters: [
      '*',
      'route.stops.*',
      'route.actualStart',
      'route.status',
      'route.stops.location.*',
      'stop.*',
      'stop.actualArrival',
      'stop.route.*',
      'stop.location.*',
      'stop.location.deliveryDays',
      'stop.location.locationOverrideTimeWindows.*',
      'stop.location.timeWindowType.*',
      'stop.location.timeWindowType.timeWindowTypeDays.*',
      'stop.cancelCode',
      'stop.orders.*',
      'organization.*',
      'stop.stopType.id',
      'stop.stopType.type',
      'stop.actualSequenceNum',
      'stop.plannedSequenceNum',
      'stop.size1AliasConfig.*',
      'stop.size2AliasConfig.*',
      'stop.size3AliasConfig.*'
    ]
  };

  const payload = {
    criteriaChain: [
      {
        and: [
          { attr: 'route.id', eq: routeId }
        ]
      }
    ],
    sort: [{ attr: 'stop.plannedSequenceNum', type: 'ASC' }]
  };
  const url = `/StopView/Summary?criteria=${encodeURI(
    JSON.stringify(criteriaParams)
  )}`;

  const response = await defaultFetch(url, payload, 'POST');

  if (response.error) {
    throw new Error('Failed fetch');
  }

  return response.map((stopView) => mapStopStatus(stopView));
}

export function useStopList(routeId) {
  return useQuery({
    queryKey: ['route-monitor-stops', routeId],
    staleTime: 1000 * 60, // 1 min
    queryFn: async () => {
      if (routeId) {
        return getStopList(routeId);
      }

      return [];
    }
  });
}
